import { useLocation } from '@remix-run/react';

const useMenu = () => {
  const { pathname } = useLocation();
  const isManagePage = pathname.endsWith('/manage');
  const isBillingPage = pathname.endsWith('/billing');
  const isPreferencesPage = pathname.endsWith('/preferences');

  return {
    isManagePage,
    isBillingPage,
    isPreferencesPage,
  };
};

export default useMenu;
